module.exports = __webpack_public_path__ + "img/summerCamp-method1.45b52f45.png";